import{css as t}from"@mui/material/styles";import e from"styled-components";const o=e("div")`
  ${({moduleHasButtons:e})=>!e&&t`
      margin-bottom: ${({theme:t})=>t.spacing(25)};
    `};

  p {
    font-size: ${({theme:t})=>t.typography.fontSize}px;
    line-height: 1.5;

    :first-of-type {
      margin-top: ${({theme:t})=>t.spacing(0)};
    }
  }

  a {
    font-weight: ${({theme:t})=>t.typography.h5.fontWeight};
    line-height: 1;
    color: ${({theme:t})=>t.palette.common.white};
    text-decoration: none;
    border-bottom: 1px solid ${({theme:t})=>t.palette.common.white};
  }
`;export{o as DescriptionDiv};
//# sourceMappingURL=styles.js.map
